import React from "react";
import "./NavBar.css";
import user from "../Assets/images/user.svg";
import userlight from "../Assets/images/userlight.svg";
import { useHistory } from "react-router-dom";
import new_dg_logo from "../Assets/images/new_dg_logo.png";

function NavBar(props) {
  const { detailView } = props;
  const history = useHistory();

  const changeUser = () => {
    let img = document.querySelector("#userlogo");
    img.src = userlight;
  };
  const defaultmake = () => {
    let img = document.querySelector("#userlogo");
    img.src = user;
  };

  return (
    <div className="navbarMain">
      <div className="navbarLeft">
        <img
          src={new_dg_logo}
          alt="logo"
          className="logo"
          onClick={() => history.replace("/home")}
        />

        {detailView && (
          <button
            onClick={() => history.replace("/home")}
            className="logoutbtn backbtn"
          >
            ← Back
          </button>
        )}
      </div>

      <button
        className="logoutbtn"
        onMouseEnter={changeUser}
        onMouseLeave={defaultmake}
        onClick={() => history.replace("/logout")}
      >
        <img id="userlogo" src={user} alt="user" className="usericon" />
        Sign out
      </button>
    </div>
  );
}

export default NavBar;